import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import GigCard from '@/partials/GigCards/GigCard/GigCard.vue'
import { IMyGigsState } from '@/store/client/modules/my-gigs/types'

const GIGS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    GigCard,
    InfiniteLoading,
  },
  data() {
    return {
      anchor: '#gig-cards',
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState<IMyGigsState>('myGigs', {
      isLoading: (state: IMyGigsState) => state.freelancerArchivedList.isLoading,
      isLoaded: (state: IMyGigsState) => state.freelancerArchivedList.isLoaded,
      pagination: (state: IMyGigsState) => state.freelancerArchivedList.pagination,
      gigs: (state: IMyGigsState) => state.freelancerArchivedList.values,
    }),
  },
  async created() {
    await this.load({ limit: GIGS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myGigs/getFreelancerArchivedGigsList',
      loadMore: 'myGigs/loadMoreFreelancerArchivedGigsList',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.gigs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: GIGS_LIMIT, offset: this.gigs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Gigs - Archived'),
    }
  },
})
